export enum Device {
  Mobile = "Mobile",
  Desktop = "Desktop",
  Other = "Other",
}
